export default "__VITE_ASSET__b92b5488__"